import { render, staticRenderFns } from "./EmptyReport.vue?vue&type=template&id=6c79dd77&scoped=true&"
import script from "./EmptyReport.vue?vue&type=script&lang=js&"
export * from "./EmptyReport.vue?vue&type=script&lang=js&"
import style0 from "./EmptyReport.vue?vue&type=style&index=0&id=6c79dd77&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c79dd77",
  null
  
)

export default component.exports